module.exports = __webpack_public_path__ + "img/agence-technitoit.19f6205f.svg";